export const FETCH_ZOO_MODELS = "FETCH_ZOO_MODELS"
export const FETCH_ZOO_MODELS_SUCCESS = "FETCH_ZOO_MODELS_SUCCESS"
export const FETCH_ZOO_MODELS_FAILED = "FETCH_ZOO_MODELS_FAILED"
export const SET_OPENVINO_VERSION = "SET_OPENVINO_VERSION"
export const SET_MODEL_SOURCE = "SET_MODEL_SOURCE"
export const CONVERT_MODEL = "CONVERT_MODEL"
export const CONVERT_MODEL_SUCCESS = "CONVERT_MODEL_SUCCESS"
export const CONVERT_MODEL_FAILED = "CONVERT_MODEL_FAILED"
export const CHANGE_MODAL = "CHANGE_MODAL"